import React from "react";
import SpecificButton from "../specificButton/SpecificButton";
import { measurementProgress } from "../../vars";
import posterVideo from "../../assets/images/video-poster-mykintever.png";


function MykniteverHome({ handleClick }) {
	return (
		<div className="h-full md:max-w-[460px] mx-auto  w-full items-center flex flex-col  text-center">
			<div className="flex-1 px-4 flex items-center justify-center mx-auto w-full">
				<video poster={posterVideo} preload="metadata" className=" max-h-[calc(100vh-180px)] w-auto mx-auto w-full  border-none" muted loop autoPlay playsInline>
					<source src={measurementProgress} type="video/mp4" />
				</video>
			</div>

			<div className="w-full  md:max-w-[460px] flex flex-col justify-end text-center p-4 ">
				<h1 className="italic">Swan</h1>
				<h2 className=" mb-3 text-[24px] uppercase">Precise body measurements scan</h2>
				<div className="max-w-[150px] flex justify-center mx-auto w-full">
					<SpecificButton btnSecondary buttonFunc={handleClick} buttonText="Start" altroute="" alttxt="" />
				</div>
			</div>
		</div>
	);
}

export default MykniteverHome;
